import React from "react";
import { Container, Row, Col } from 'react-bootstrap';
import HTMLReactParser from 'html-react-parser';
import { Link } from "@StarberryUtils";
import useDeviceMedia from "../../utils/useDeviceMedia";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import ImageModule from "../../common/Image_Module";
import {LinkArrow} from "../../Icons/Icons";
import "./Guide.scss";

const Guide = (props) => {
    const { isCustomMax } = useDeviceMedia({ max: "991.98px" });

    // Image URL with a fallback
    const image_url = props?.Image?.url || "";

    // Ensure processedImages is valid
    let processedImages = JSON.stringify({});

    if (props?.imagetransforms?.Modules?.Guide_Module?.Image_Transforms) {
        processedImages = props.imagetransforms.Modules.Guide_Module.Image_Transforms;
    }
   
    const ImageSrc = {
        url:props?.Image?.url
    }
    // Limit the guides to 8 if on mobile
    const guidesToShow = isCustomMax
        ? props?.GuideList?.area_guides?.slice(0, 8)
        : props?.GuideList?.area_guides;
    const ggfx = [{
    ...props?.ggfx_results
  }]
    return (
        <section className="guide-module-wrap">
            <Container fluid>
                <Row>
                  
                    <Col xl={6} className="d-flex guide-left">
                        <div className="guide-content">
                            {props.Title && <h4>{props.Title}</h4>}
                            {props.Content && (
                                <div className="guide-block-text text-sm">
                                    {HTMLReactParser(props.Content.replace(/<br\s*\/?>/gi, ''))}
                                </div>
                            )}
                            {props?.ShowGuides && guidesToShow?.length > 0 && (
                                <ul className="guide-list">
                                    {guidesToShow.map((guide) => (
                                        <li key={guide.id} className="guide-item">
                                            <Link to={`/living-in-dubai/${guide.URL}`} className="text-sm">{guide.Title} <span className="link-icon"><LinkArrow /></span></Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            <div className="guide-btn-wrapper d-flex d-md-none">
                                {props.ButtonLabel && props.ButtonLink && (
                                    <Link to={props.ButtonLink} className="btn btn-primary">
                                        {props?.ButtonLabel}
                                    </Link>
                                )}
                            </div>
                        </div>
                    </Col>
                    <Col xl={6} className="p-0 d-flex guide-right">
                        <div className="guide-image img-zoom">
                            {image_url && (
                                // <ImageTransform 
                                //     imagesources={image_url} 
                                //     renderer="srcSet" 
                                //     imagename="articles.Modules_Guide_Module_Image.tile_image" 
                                //     attr={{ alt: `${props?.Image?.alternativeText || 'Guide Banner'} - Dacha` }} 
                                //     imagetransformresult={processedImages} 
                                //     id={props.id} 
                                // />
                        //         <ImageModule 
                        //           ImageSrc={ImageSrc} 
                        //           attr={{ alt: props?.Image?.alternativeText + ' - Dacha', class: '' }} 
                        //           ggfx_results={ggfx} 
                        //           imagename="articles.Modules_Guide_Module_Image.tile_image" 
                        //           strapi_id={props?.id} 
                        //   />   
                        <img src={image_url}></img>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Guide;